import { IconX } from 'featherico';
import { useState } from 'react';
import NotificationsTrigger from '../../react/components/Notifications/NotificationsTrigger/withProvider';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import HelpMenu from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import HeaderSearchBar from '../../react/features/HeaderSearchBar/container';
import { useJustLaunched } from '../../react/features/Navigation/List/justLaunchedHasUpdateService';
import { useAppContext } from '../../react/hooks/useAppContext';
import styles from './style.m.less';

const JUST_LAUNCHED_URL = 'https://www.small-improvements.com/release-notes#notes-section';
const LAST_UPDATED = new Date('2026-03-18');

export default function Actions() {
    const [searchFocused, setSearchFocused] = useState(false);
    const { user } = useAppContext();
    const justLaunched = useJustLaunched(LAST_UPDATED, user);

    return (
        <div className={styles.container}>
            {justLaunched.shouldShow && (
                <div className={styles.justLaunchedCard}>
                    <a
                        className={styles.justLaunchedCardLink}
                        href={JUST_LAUNCHED_URL}
                        onClick={justLaunched.dismiss}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <span className={styles.justLaunchedCardTitle}>New in Surveys: Group by Rating</span>
                    </a>
                    <button
                        type="button"
                        className={styles.justLaunchedCardClose}
                        aria-label="Close"
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            justLaunched.dismiss();
                        }}
                    >
                        <IconX />
                    </button>
                </div>
            )}

            <div className={styles.actions}>
                {!user.isGuest && (
                    <>
                        {!searchFocused && <GlobalCreate user={user} />}
                        <HeaderSearchBar
                            onFocus={() => setSearchFocused(true)}
                            onBlur={() => setSearchFocused(false)}
                        />
                    </>
                )}
                {!searchFocused && (
                    <>
                        <HelpMenu />
                        <NotificationsTrigger />
                    </>
                )}
            </div>

            <UserMenu user={user} />
        </div>
    );
}
